var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTitle, Grid, GridColumn, List, ListItem, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import HasMandate from '../../auth/HasMandate';
import { MandateType } from '../../config/mandate';
import { createGaEvent } from '../../util/GaUtil';
import RepresentationRightsAddMandateModal from './RepresentationRightsAddMandateModal';
import RepresentationRightsCustomerMandates from './RepresentationRightsCustomerMandates';
import RepresentationRightsPersonMandates from './RepresentationRightsPersonMandates';
import { injectStores } from '../../util/StoresUtil';
let RepresentationRights = class RepresentationRights extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createGaEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                createGaEvent({
                    eventCategory: 'Iseteenindus - Konto',
                    eventAction: 'personPowers.title',
                    eventLabel: 'oldSelfService.button'
                });
            }
        });
    }
    render() {
        const { translate } = this.translateStore;
        return (React.createElement(GridColumn, { width: ['xs-12'] },
            React.createElement(Accordion, { defaultOpenItem: this.shouldOpenRepresentationRightsAccordion() ? ['representation-rights-accordion'] : [], onToggle: () => this.createGaEvent() },
                React.createElement(AccordionItem, { id: "representation-rights-accordion" },
                    React.createElement(AccordionHeader, null,
                        React.createElement(Grid, { gutter: "none", align: ['middle-xs'] },
                            React.createElement(GridColumn, null,
                                React.createElement(AccordionTitle, { className: "h3 text-bold" }, translate('personPowers.title'))),
                            React.createElement(GridColumn, null,
                                React.createElement(List, { bordered: true, direction: "inline", type: "unstyled" },
                                    React.createElement(ListItem, null, translate('personPowers.description')))))),
                    React.createElement(AccordionContent, null,
                        React.createElement(RepresentationRightsCustomerMandates, null),
                        React.createElement(Separator, { color: "invisible", spacing: "small" }),
                        this.renderAddMandateButton(),
                        React.createElement(Separator, { spacing: "medium" }),
                        React.createElement(RepresentationRightsPersonMandates, null))))));
    }
    shouldOpenRepresentationRightsAccordion() {
        return window.location.hash && window.location.hash.endsWith('representation-rights');
    }
    renderAddMandateButton() {
        return (React.createElement(HasMandate, { mandates: [MandateType.LEGAL], matchAll: true },
            React.createElement(RepresentationRightsAddMandateModal, null)));
    }
};
RepresentationRights = __decorate([
    injectStores,
    observer
], RepresentationRights);
export default RepresentationRights;
